const AUTH_RATE_LIMIT_PATHS = new Set(['/v1/auth', '/v1/auth/refresh']);

function requestPath(url: string | undefined): string | undefined {
  if (!url) return undefined;

  try {
    const path = url.startsWith('http') ? new URL(url).pathname : url;
    return path.split('?')[0];
  } catch {
    return undefined;
  }
}

/** 429 from sign-in or session refresh. Other API 429s stay on the current page. */
export function isAuthRateLimited(
  status: number | undefined,
  url: string | undefined,
): boolean {
  if (status !== 429) return false;

  const path = requestPath(url);
  return path !== undefined && AUTH_RATE_LIMIT_PATHS.has(path);
}
